export function getSimpleHashByString(source: string): number {
    let result = 0;
    for (let index = 0; index < source.length; index++) {
        result = ((result << 5) - result + source.charCodeAt(index)) | 0;
    }
    return result;
}

export const generateSimpleHash = (length = 8): string => {
    let result = "";
    while (result.length < length) {
        result += Math.random().toString(36).slice(2);
    }
    return result.slice(0, length);
};
